var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "show-close": true,
        title: _vm.$t("scripting.packageConfirmation"),
        visible: _vm.printTipsVisible,
        top: "10vh",
        width: "650px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.printTipsVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticStyle: { "max-height": "500px", "overflow-y": "auto" } },
        [
          _c(
            "table",
            { staticClass: "confirm-table" },
            [
              _c("tr", [
                _c("td", { staticClass: "label" }, [
                  _vm._v(_vm._s(_vm.$t("collectionCenter.scanInfo")) + ":"),
                ]),
                _c("td", { staticClass: "value", attrs: { colspan: "2" } }, [
                  _vm._v(_vm._s(_vm.tipDataList[0].invoiceAccessKey || "-")),
                ]),
              ]),
              _c("tr", [
                _c("td", { staticClass: "label" }, [
                  _vm._v(
                    _vm._s(_vm.$t("scripting.associatedPackageCount")) + ":"
                  ),
                ]),
                _c("td", { staticClass: "value", attrs: { colspan: "2" } }, [
                  _vm._v(_vm._s(_vm.tipDataList.length || 0)),
                ]),
              ]),
              _c("tr", [
                _c("td", { staticClass: "label" }, [
                  _vm._v(
                    _vm._s(_vm.$t("scripting.packageWaybillNumber")) + ":"
                  ),
                ]),
                _c("td", { staticClass: "value" }, [
                  _vm._v(_vm._s(_vm.tipDataList[0].waybillNumber || "-")),
                ]),
              ]),
              _vm._l((_vm.tipDataList || []).slice(1), function (item, index) {
                return _c("tr", { key: index }, [
                  _c("td", { staticClass: "label" }),
                  _c("td", { staticClass: "value" }, [
                    _vm._v(_vm._s(item.waybillNumber)),
                  ]),
                ])
              }),
            ],
            2
          ),
        ]
      ),
      _c("div", { staticStyle: { "margin-left": "30px", color: "red" } }, [
        _vm._v(_vm._s(_vm.$t("scripting.verifyPackageCountNotice"))),
      ]),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small" },
              on: {
                click: function ($event) {
                  _vm.printTipsVisible = false
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("scripting.cancelPrint")) + " ")]
          ),
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary" },
              on: { click: _vm.clickPrint },
            },
            [_vm._v(" " + _vm._s(_vm.$t("GlobalSetObj.Confirmed")) + " ")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }